import { render, staticRenderFns } from "./UserAdd.vue?vue&type=template&id=9ec65fda&scoped=true&"
import script from "./UserAdd.vue?vue&type=script&lang=js&"
export * from "./UserAdd.vue?vue&type=script&lang=js&"
import style0 from "./UserAdd.vue?vue&type=style&index=0&id=9ec65fda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec65fda",
  null
  
)

export default component.exports